import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';
import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

export const InventoryDashboard = lazyWithRetry(() =>
  import('@erp/inventory/pages/InventoryDashboard.tsx'),
);

const inventoryNode = {
  component: InventoryDashboard,
} satisfies ComponentPage;

const inventoryRoutes: ComponentOrMapping = {
  erp: {
    inventory: inventoryNode,
  },
};

export default inventoryRoutes;
